/* import __COLOCATED_TEMPLATE__ from './confirm-cancel-invitation-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();